angular.module('app.player.telestrate.telestrateControlsController', [])
  .controller('app.player.telestrate.telestrateControlsController', [
    '$scope',
    function ($scope) {
      "use strict";

      $scope.toolbox = $scope.toolbox || null;
      $scope.colorClassSuffix = $scope.toolbox.color;

      let setFillDiameter = function (size,type) {
        switch (size) {
          case 'x-small':
            if(type == 'eraser') {
              $scope.toolbox.fillDiameter = 4;
            } else {
              $scope.toolbox.fillDiameter = 2;
            }
            break;
          case 'small':
            if(type == 'eraser') {
              $scope.toolbox.fillDiameter = 12;
            } else {
              $scope.toolbox.fillDiameter = 6;
            }
            break;
          case 'medium':
            if(type == 'eraser') {
              $scope.toolbox.fillDiameter = 20;
            } else {
              $scope.toolbox.fillDiameter = 10;
            }
            break;
          case 'large':
            if(type == 'eraser') {
              $scope.toolbox.fillDiameter = 28;
            } else {
              $scope.toolbox.fillDiameter = 14;
            }
            break;
          default:
            $scope.toolbox.fillDiameter = 10;
        }
      };

      $scope.telestrateReturnColorClass = function (color) {
        return 'video-player__telestrate__color-div__color--' + color;
      };

      $scope.telestrateReturnBrushClass = function (size) {
        return 'video-player__telestrate__brush-div__brush--' + size;
      };

      $scope.telestrateReturnEraserClass = function (size) {
        return 'video-player__telestrate__eraser-div__eraser--' + size;
      };

      $scope.telestrateColorClick = function (color) {

        let colors = {
          blue: '#0076ff',
          red: '#e92a25',
          yellow: '#f8e71c',
          green: '#7ed321',
          orange: '#f5a623',
          white: '#fff',
          gray: '#999',
          black: '#383838'
        };

        $scope.colorClassSuffix = color;
        $scope.toolbox.color = colors[color] || '#0076ff';
      };

      $scope.telestrateBrushClick = function (size) {
        $scope.toolbox.isClearing = false;

        $scope.toolbox.brush = size;
        $scope.toolbox.eraser = 'brush';

        setFillDiameter(size,'brush');
      };

      $scope.telestrateEraserClick = function (size) {
        $scope.toolbox.isClearing = true;

        $scope.toolbox.eraser = size;
        $scope.toolbox.brush = 'eraser';

        setFillDiameter(size,'eraser');
      };

      $scope.telestrateClearAllClick = function () {
        $scope.toolbox.clearCanvas = true;
      };


      let init = function () {

      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/telestrate/telestrateControls/telestrateControlsController.js